import Entity from '../entity'
import Coupon from './Coupon';

export default class CouponType extends Entity<number>{
    couponTypeNo: string  = null;
    name: string  = null;
    displayName: string  = null;
    tenantId: number  = null;
    couponBackgroundImageUrl: string  = null;
    minimumUsingAmount: number  = null;
    deductionAmount: string  = null;
    expiredTime: Date  = null;
    isPublished: boolean;
    couponUseUrl: string  = null;
    remark: string  = null;
    coupons: Array<Coupon>;
}